<template>
  <v-container class="my-12" v-if="item">
    <v-row class="align-center">
      <v-col
        cols="12"
        md="6"
        v-if="item.img"
        class="mt-6 mt-md-12 pr-3 pr-md-16"
      >
        <img
          loading="lazy"
          :src="files + item.img + `?resize=1&w=960`"
          :alt="item.title"
          class="featured-img"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        v-if="item.title || item.text"
        class="mt-6 mt-md-12"
      >
        <div class="white--text font-weight-black item-title">
          {{ item.title }}
        </div>

        <div
          class="white--text font-weight-regular mt-6 item-text"
          v-if="item.text"
          v-html="item.text"
        ></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    item: {},
  }),
  props: {
    itemId: {
      type: Number,
      required: true,
    },
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.$rest("team")
        .get({
          id: this.itemId,
        })
        .then((data) => {
          this.item = data;
        });
    },
  },
};
</script>

<style scoped>
.featured-img {
  height: auto;
  width: 100%;
}

.item-title {
  font-size: 28px;
  line-height: 33px;
}

.item-text {
  font-size: 16px;
  line-height: 24px;
}
</style>
